import React from 'react';
import PropTypes from 'prop-types';
import ExpandableList from "../ExpandableList";
import TrackStatusIcon from "../../Icons/TrackStatusIcon";
import { TRACK_STATUS_OPEN } from "../../../../config/constants";
import LegendBlockItemsList from "../LegendBlockItemsList";
import { getOpenTracksObject, getWorkingTracksCount, sortTracksObject } from "../../../../helpers/map";
import { t } from "../../../../lang/trans";

const LegendOpenTracksInfo = ({ isOpen, tracks, onToggle, onClickOnTrack }) => {
	const title = `${t('працює')}: ${getWorkingTracksCount(tracks)} / ${Object.keys(tracks).length}`;

	const preparedTracks = sortTracksObject(getOpenTracksObject(tracks));

	return (
		<ExpandableList
			isOpen={isOpen}
			title={title}
			iconComponent={<TrackStatusIcon status={TRACK_STATUS_OPEN} size={30}/>}
			onToggle={() => onToggle()}
		>
			<LegendBlockItemsList tracks={preparedTracks} onClickOnTrack={onClickOnTrack}/>
		</ExpandableList>
	)
};

LegendOpenTracksInfo.propTypes = {
	blockOpenTracksIsOpen: PropTypes.bool,
	tracks: PropTypes.object,
	onToggle: PropTypes.func,
	onClickOnTrack: PropTypes.func,
};

export default LegendOpenTracksInfo;